import styled from 'styled-components'

export const StyledLabel = styled.label<{ checked: boolean; disabled?: boolean }>`
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
  text-indent: -9999px;
  width: ${({ theme }) => theme.UI.Spacing.Space11}px;
  height: ${({ theme }) => theme.UI.Spacing.Space6}px;
  background: ${({ checked, theme }) => (checked ? theme.Colors.Status.Success : theme.Colors.Status.Disabled)};
  display: block;
  border-radius: 100px;
  position: relative;
  &:after {
    content: '';
    position: absolute;
    left: ${({ checked, theme }) => (checked ? 'calc(55% - 2px)' : theme.UI.Spacing.Space1 / 2 + 'px')};
    top: ${({ theme }) => theme.UI.Spacing.Space1 / 2}px;
    width: ${({ theme }) => theme.UI.Spacing.Space5}px;
    height: ${({ theme }) => theme.UI.Spacing.Space5}px;
    background: #fff;
    border-radius: 100%;
    transition: 0.3s;
  }
`
